/* eslint-disable no-dupe-keys */
// eslint-disable-next-line no-undef
const BASE_URL = `${siteUrl}api/gms/v1/general/`;

export default {
    /**
     * Get suntimes for a given date.
     *
     * @return {Array} [{Object}, ...]
     */
    getSunTimesForDate(date) {
        return new Promise((resolve, reject) => {
            axios.get(`${BASE_URL}suntimes/${date}`)
            .then((response) => {
                if (!response.data.success) {
                    throw response.data.result.errors;
                }

                resolve(response.data.result);
            })
            .catch((error) => {
                // handle error
                console.log(error);
                reject(error);
            });
        });
    },

    /**
     * Get overall status of the course.
     *
     * @return {Array} [{Object}, ...]
     */
    getStatus() {
        return new Promise((resolve, reject) => {
            axios.get(`${BASE_URL}status`)
            .then((response) => {
                if (!response.data.success) {
                    throw response.data.result.errors;
                }

                resolve(response.data.result);
            })
            .catch((error) => {
                // handle error
                console.log(error);
                reject(error);
            });
        });
    },

    /**
     * Get a list of available countries.
     *
     * @return {Array} [{Object}, ...]
     */
    getCountries() {
        return new Promise((resolve, reject) => {
            axios.get(`${BASE_URL}get-countries`)
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                // handle error
                console.log(error);
                reject(error);
            });
        });
    },
    /**
     * Get a list of available countries.
     *
     * @return {Array} [{Object}, ...]
     */
    getCountries() {
        return new Promise((resolve, reject) => {
            axios.get(`${BASE_URL}get-countries`)
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                // handle error
                console.log(error);
                reject(error);
            });
        });
    },

    /**
     * Get a list of available lesson types.
     *
     * @return {Array} [{Object}, ...]
     */
    getLessonContentTypes() {
        return new Promise((resolve, reject) => {
            axios.get(`${BASE_URL}lesson-content-types`)
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                // handle error
                console.log(error);
                reject(error);
            });
        });
    },

    /**
     * Get a list of available lesson types.
     *
     * @return {Array} [{Object}, ...]
     */
    getLessonTypes() {
        return new Promise((resolve, reject) => {
            axios.get(`${BASE_URL}lesson-types`)
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                // handle error
                console.log(error);
                reject(error);
            });
        });
    },
};
